import * as React from 'react';

const SvgUpdateFacebook = (props) => (
  <svg
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle cx={18} cy={18} r={15.75} fill='url(#updateFacebook_svg__a)' />
    <path
      d='m23.865 22.817.7-4.446h-4.377v-2.883c0-1.217.61-2.403 2.57-2.403h1.992V9.3S22.944 9 21.218 9c-3.606 0-5.961 2.13-5.961 5.983v3.388H11.25v4.446h4.007v10.747c.804.123 1.627.186 2.466.186.838 0 1.66-.063 2.465-.186V22.817h3.677Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='updateFacebook_svg__a'
        x1={18}
        y1={2.25}
        x2={18}
        y2={33.657}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#18ACFE' />
        <stop offset={1} stopColor='#0163E0' />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgUpdateFacebook;
